export const validationInfo = {
    hin: {
        feedbackMessage: "Please enter a valid Hin.",
        placeholder:"HIN",
        maxLength:"9",
        minLength:"9",
        pattern:"[a-zA-Z0-9]{9}",
        required: false
    }
}